import { SHOW_TAB_SCAN_TICKET_ALWAYS } from '~/config/featureFlags.js'

export default defineNuxtRouteMiddleware((to) => {
	const config = useRuntimeConfig()
	const tokenCookie = useCookie<string | null>(config.public.auth.name_cookie)
	const token = tokenCookie.value

	const { $i18n, $hasFeature } = useNuxtApp()
	const localePath = useLocalePath()

	const normalize = (p: string) => p.replace(/\/+$/, '') || '/'
	const currentLocale = $i18n.locale.value
	const current = normalize(to.path)

	const go = (path: string) => {
		const localized = normalize(localePath(path, currentLocale))

		if (current === localized) return

		return navigateTo({
			path: localized,
			query: to.query,
			hash: to.hash,
			replace: true,
		})
	}

	if (!token && !$hasFeature(SHOW_TAB_SCAN_TICKET_ALWAYS)) {
		return go('/results')
	}
})
